<script>
import { mapStores } from "pinia";

import { buildCountTypeHeader } from "@/components/article/dictsys/inflectionSchemes/labels";
import lang from "@/directives/lang";
import { useInflectionSchemeStore, useSettingsStore } from "@/stores";

export default {
  name: "NounInflectionSchemeModal",
  directives: {
    lang
  },
  props: {
    lemma: {
      type: String,
      required: true
    },
    inflectionScheme: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      supportedCountTypes: ["singular", "plural"]
    };
  },
  computed: {
    ...mapStores(useInflectionSchemeStore, useSettingsStore),

    inflectionLanguage() {
      return this["inflection-schemeStore"].inflectionSchemeLanguage;
    },

    wordclassLevel() {
      return this.settingsStore.activeWordClassLevel;
    },
    countTypes() {
      return Object.keys(this.scheme);
    },
    countTypeHeaders() {
      return this.countTypes.map((type) => buildCountTypeHeader(this.wordclassLevel, type));
    },
    scheme() {
      return this.supportedCountTypes.reduce((scheme, type) => {
        const inflection = this.inflectionScheme.common.indefinite[type];

        if (!inflection) {
          return scheme;
        }

        return {
          ...scheme,
          [type]: inflection[0]?.inflexion ?? "-"
        };
      }, {});
    }
  }
};
</script>

<template>
  <table class="table inflection-scheme-modal__table">
    <caption class="sr-only">
      {{
        $t("article.inflectionScheme.caption", { word: lemma })
      }}
    </caption>

    <thead>
      <tr>
        <th
          v-for="header in countTypeHeaders"
          :key="header"
          scope="col"
          class="inflection-scheme-modal__th w-100"
        >
          {{ header }}
        </th>
      </tr>
    </thead>
    <tbody v-lang:[inflectionLanguage]>
      <tr class="inflection-scheme-modal__tr">
        <td v-for="countType in countTypes" :key="countType" class="inflection-scheme-modal__td">
          {{ scheme[countType] }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
